import React, { lazy, Suspense, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
    SecondAds,
    FirstAds,
    MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const BodyFatTable = lazy(() => import("./BodyFatTable"));
const TITLE = 'Kalkulator Persentase Lemak Tubuh';
const DESCRIPTION = 'Kalkulator ini menghitung persentase lemak tubuh, persentase lemak tubuh normal untuk pria dan wanita, serta persentase lemak normal lainnya.';
const KEYWORDS = 'persentase lemak tubuh, hitung persentase lemak tubuh, kalkulator persentase lemak, persentase lemak normal, mengukur persentase lemak, ketahui persentase lemak, kalkulator persentase lemak untuk pria dan wanita, nutrisi sehat, hitung persentase lemak tubuh, hitung massa lemak, mengukur persentase lemak tubuh';
const OG_URL = 'https://do-calculate.com/calculator/id/bodyfat/';
function BodyFatCalculator() {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [neckMeasurement, setNeckMeasurement] = useState("");
    const [waistMeasurement, setWaistMeasurement] = useState("");
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const calculateBodyFatLocal = (weight, waistMeasurement, neckMeasurement, height, age, gender) => {
        try {
            const weightInches = weight * 0.393701;
            const waistInches = waistMeasurement * 0.393701;
            const neckInches = neckMeasurement * 0.393701;
            const heightInches = height * 0.393701;
            let bodyFatPercentage;
            if (gender.toLowerCase() === 'male') {
                bodyFatPercentage = (86.010 * Math.log10(waistInches - neckInches)) - (70.041 * Math.log10(heightInches)) + 36.76;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else if (gender.toLowerCase() === 'female') {
                bodyFatPercentage = (163.205 * Math.log10(waistInches + waistInches - neckInches)) - (97.684 * Math.log10(heightInches)) - 78.387;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else {
                throw new Error('Invalid gender. Only "male" and "female" are allowed.');
            }
            let bodyFatCategory = null;
            if (gender.toLowerCase() === 'male') {
                if (bodyFatPercentage < 2) {
                    bodyFatCategory = 'Less than Essential Fat';
                    bodyFatPercentage = 0;
                } else if (bodyFatPercentage >= 2 && bodyFatPercentage <= 5) {
                    bodyFatCategory = 'Essential Fat';
                } else if (bodyFatPercentage > 5 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Athletes';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 17) {
                    bodyFatCategory = 'Fitness';
                } else if (bodyFatPercentage > 17 && bodyFatPercentage <= 25) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 25) {
                    bodyFatCategory = 'Obese';
                }
            } else if (gender.toLowerCase() === 'female') {
                if (bodyFatPercentage >= 10 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Essential Fat';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 20) {
                    bodyFatCategory = 'Athletes';
                } else if (bodyFatPercentage > 20 && bodyFatPercentage <= 24) {
                    bodyFatCategory = 'Fitness';
                } else if (bodyFatPercentage > 24 && bodyFatPercentage <= 32) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 32) {
                    bodyFatCategory = 'Obese';
                }
            }
            if (bodyFatCategory === null) {
                throw new Error('Unable to determine body fat category.');
            }
            const fatMass = ((bodyFatPercentage / 100) * weight).toFixed(2);
            const leanMass = (weight - fatMass).toFixed(2);
            let idealBodyFatPercentage = 0;
            if (gender.toLowerCase() === 'male') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 8.5;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 10.5;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 12.7;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 13.7;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 15.3;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 16.4;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 18.9;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 20.9;
                }
            } else if (gender.toLowerCase() === 'female') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 17.7;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 18.4;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 19.3;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 21.5;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 22.2;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 22.9;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 25.2;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 26.3;
                }
            }
            let bodyFatToLose = 0;
            if (age >= 20) {
                bodyFatToLose = ((bodyFatPercentage - idealBodyFatPercentage) / 100 * weight).toFixed(2);
            }
            const result = {
                bodyFatPercentage,
                fatMass,
                leanMass,
                bodyFatCategory,
                idealBodyFatPercentage,
                bodyFatToLose
            };
            return { result };
        } catch (error) {
            throw error;
        }
    };
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleNeckMeasurementChange = (event) => {
        setNeckMeasurement(event.target.value);
    };
    const handleWaistMeasurementChange = (event) => {
        setWaistMeasurement(event.target.value);
    };
    const calculateBodyFat = () => {
        setIsLoading(true);
        setError(null);
        setStatusCode(null);
        try {
            if (!weight || !height || !age || !gender || !neckMeasurement || !waistMeasurement) {
                setError("Harap masukkan semua field dengan benar.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const weightNum = parseFloat(weight);
            const heightNum = parseFloat(height);
            const ageNum = parseInt(age);
            const neckNum = parseFloat(neckMeasurement);
            const waistNum = parseFloat(waistMeasurement);
            if (isNaN(weightNum) || isNaN(heightNum) || isNaN(ageNum) || isNaN(neckNum) || isNaN(waistNum)) {
                setError("Harap masukkan nilai angka yang valid.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const calculationResult = calculateBodyFatLocal(
                weightNum,
                waistNum,
                neckNum,
                heightNum,
                ageNum,
                gender
            );
            setResult(calculationResult.result);
            setClassification(calculationResult.result.bodyFatCategory);
            setStatusCode(200);
        } catch (error) {
            console.error(error);
            setError("Terjadi kesalahan saat menghitung. Harap periksa data yang dimasukkan.");
            setStatusCode(400);
            setResult(null);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white  text-center  justify-content-center align-items-center" style={{ height: '35px' }}>
                        <h1 style={{ fontSize: '16px' }}>Kalkulator Persentase Lemak Tubuh untuk Pria dan Wanita</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Kalkulator persentase lemak tubuh menghitung persentase lemak dalam tubuh serta persentase lemak normal untuk pria dan wanita, termasuk lemak trigliserida normal dan persentase lemak dalam darah, yaitu persentase lemak dari total berat badan.
                                <br />
                                Kalkulator persentase lemak tubuh memungkinkan Anda untuk menghitung dan mengukur persentase lemak tubuh menggunakan berbagai rumus seperti rumus Jackson & Pollard. Kalkulator ini sangat penting untuk memperkirakan kesehatan dan tingkat kebugaran tubuh seseorang.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Persentase Lemak Tubuh
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='height' className="form-label ms-2" >Tinggi Badan</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="height"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '100%' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='weightNumber' className="form-label ms-2">Berat Badan</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">kg</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='age' className="form-label ms-2">Usia</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="age"
                                        value={age}
                                        onChange={handleAgeChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="33"
                                        min="2"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Jenis Kelamin</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            id="male"
                                            checked={gender === "male"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="male">
                                            Pria
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            id="female"
                                            checked={gender === "female"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="female">
                                            Wanita
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label className="form-label ms-2">Lingkar Pinggang</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="waistMeasurement"
                                        value={waistMeasurement}
                                        onChange={handleWaistMeasurementChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="90"
                                        min="2"
                                        max="20"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label className="form-label ms-2">Lingkar Leher</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="neckMeasurement"
                                        value={neckMeasurement}
                                        onChange={handleNeckMeasurementChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="47"
                                        min="2"
                                        max="20"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateBodyFat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Hitung'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                {result && (
                                    <div>
                                        <div className="alert alert-success">
                                            <h5>Hasil Perhitungan :</h5>
                                        </div>
                                        <hr />
                                        <Suspense fallback={<div>Loading...</div>}>
                                            <BodyFatTable result={result} />
                                        </Suspense>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Terjadi Kesalahan :</u></b> Harap masukkan semua field dengan benar. </div>}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">{TITLE}
                                :</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Apa itu Persentase Lemak Tubuh?
                                </h2> </u>
                                Persentase lemak tubuh adalah persentase jumlah lemak yang tersimpan di dalam tubuh dibandingkan dengan total berat badan Anda. Lemak ini terdiri dari lemak esensial dan lemak yang disimpan di berbagai jaringan adiposa. Persentase lemak tubuh dapat diklasifikasikan ke dalam beberapa kategori berdasarkan kesehatan dan kebugaran fisik secara keseluruhan:
                                <ul>
                                    <li>
                                        Persentase lemak normal: Ini adalah persentase lemak yang sehat dalam tubuh, biasanya berkisar antara 15% hingga 20% untuk wanita dan 10% hingga 15% untuk pria.
                                    </li>
                                    <li>
                                        Persentase lemak berlebih: Jika persentase lemak melebihi angka standar ini, dapat meningkatkan risiko penyakit seperti obesitas, penyakit jantung, dan diabetes.
                                    </li>
                                    <li>
                                        Kekurangan persentase lemak: Jika persentase lemak lebih rendah dari angka standar, dapat menyebabkan masalah kesehatan seperti osteoporosis dan kekurangan nutrisi.
                                    </li>
                                </ul>
                                <u><h2 style={{ fontSize: '16px' }}>Cara Menghitung Persentase Lemak Tubuh:
                                </h2> </u>
                                Ada banyak cara berbeda untuk mengukur persentase lemak tubuh, di antaranya yang paling populer adalah:
                                <ul>
                                    <li>
                                        Menggunakan kalkulator persentase lemak tubuh: Anda dapat menggunakan kalkulator persentase lemak tubuh online yang telah kami kembangkan. Anda hanya perlu memasukkan beberapa informasi seperti berat badan, tinggi badan, usia, dan jenis kelamin.
                                    </li>
                                    <li>
                                        Menggunakan alat pengukur lemak tubuh: Di pasaran tersedia alat pengukur lemak tubuh yang menggunakan teknologi seperti bioelectrical impedance.
                                    </li>
                                    <li>
                                        Pengukuran oleh profesional: Anda dapat meminta bantuan dari pelatih kebugaran atau dokter untuk mengukur persentase lemak tubuh menggunakan alat khusus.
                                    </li>
                                </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Cara Kerja Kalkulator Persentase Lemak Tubuh
                                    : </h2> </u>
                                <p>
                                    Kalkulator ini cocok untuk orang biasa yang ingin menghitung persentase lemak tubuh. Kalkulator ini menghitung lemak tubuh berdasarkan beberapa pengukuran seperti berat badan, lingkar pinggang, lingkar leher, tinggi badan, usia, dan jenis kelamin.
                                    Saat menggunakan kalkulator, pengguna harus memasukkan nilai berat badan, lingkar pinggang, lingkar leher, tinggi badan, usia, dan jenis kelamin. Kemudian kalkulator akan menghitung persentase lemak tubuh berdasarkan rumus yang ada di dalam kode.
                                </p>
                                Setelah perhitungan, kalkulator akan mengembalikan hasil berikut:
                                <br />
                                <ul>
                                    <li>
                                        Persentase lemak tubuh.
                                    </li>
                                    <li>
                                        Massa lemak.
                                    </li>
                                    <li>
                                        Massa otot (lean mass).
                                    </li>
                                    <li>
                                        Klasifikasi persentase lemak tubuh berdasarkan pedoman ACE.
                                    </li>
                                    <li>
                                        Persentase lemak tubuh ideal berdasarkan usia dan jenis kelamin.
                                    </li>
                                    <li>
                                        Massa lemak yang perlu dikurangi untuk mencapai persentase lemak ideal.
                                    </li>
                                </ul>
                                <hr />
                                <b>    Persentase Lemak Tubuh Ideal Menurut Jackson & Pollard</b>
                                <div >
                                    <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">Usia</th>
                                                <th className="formula-header">Wanita</th>
                                                <th className="formula-header">Pria</th>
                                            </tr>
                                            <tr>
                                                <td>20</td>
                                                <td>17.7%</td>
                                                <td>8.5%</td>
                                            </tr>
                                            <tr>
                                                <td>25</td>
                                                <td>18.4%</td>
                                                <td>10.5%</td>
                                            </tr>
                                            <tr>
                                                <td>30</td>
                                                <td>19.3%</td>
                                                <td>12.7%</td>
                                            </tr>
                                            <tr>
                                                <td>35</td>
                                                <td>21.5%</td>
                                                <td>13.7%</td>
                                            </tr>
                                            <tr>
                                                <td>40</td>
                                                <td>22.2%</td>
                                                <td>15.3%</td>
                                            </tr>
                                            <tr>
                                                <td>45</td>
                                                <td>22.9%</td>
                                                <td>16.4%</td>
                                            </tr>
                                            <tr>
                                                <td>50</td>
                                                <td>25.2%</td>
                                                <td>18.9%</td>
                                            </tr>
                                            <tr>
                                                <td>55</td>
                                                <td>26.3%</td>
                                                <td>20.9%</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                                <br />                                Hasil ini dapat digunakan untuk memahami persentase lemak tubuh saat ini dan yang diinginkan, serta untuk memandu upaya nutrisi dan kebugaran di masa depan.
                                <br />                                <div className=' p-3 mb-2 bg-info text-black'>
                                    Perlu dicatat bahwa kalkulator ini hanya berdasarkan estimasi dan rumus tertentu, dan bukan pengganti konsultasi dengan dokter atau ahli yang berkualifikasi. Jika Anda ingin mengetahui persentase lemak tubuh secara akurat atau mendapatkan saran pribadi, sebaiknya berkonsultasi dengan profesional berpengalaman.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BodyFatCalculator;